import { apiClient } from '../../../../../lib/axios';
import type {
  AtRiskUsersParams,
  AtRiskUsersResponse,
  CardiovascularJeopardyParams,
  CardiovascularJeopardyResponse,
} from './types';

const buildQueryParams = (params?: Partial<AtRiskUsersParams & CardiovascularJeopardyParams>) => {
  const queryParams: Record<string, unknown> = {};

  if (params?.risk && params.risk !== 'all') {
    queryParams.risk = params.risk;
  }
  if (params?.status) {
    queryParams.status = params.status;
  }
  if (params?.activity) {
    queryParams.activity = params.activity;
  }
  if (params?.start_date) {
    queryParams.start_date = params.start_date;
  }
  if (params?.end_date) {
    queryParams.end_date = params.end_date;
  }
  if (params?.page) {
    queryParams.page = params.page;
  }
  if (params?.page_size) {
    queryParams.page_size = params.page_size;
  }
  if (params?.department && params.department.length > 0) {
    queryParams.department = params.department;
  }
  if (params?.client_id) {
    queryParams.client_id = params.client_id;
  }
  if (params?.age_range && params.age_range.length > 0) {
    queryParams.age_range = params.age_range;
  }
  if (params?.sex) {
    queryParams.sex = params.sex;
  }
  if (params?.shift_pattern && params.shift_pattern.length > 0) {
    queryParams.shift_pattern = params.shift_pattern;
  }
  if (params?.job_role && params.job_role.length > 0) {
    queryParams.job_role = params.job_role;
  }
  if (params?.user_ids && params.user_ids.length > 0) {
    queryParams.user_ids = params.user_ids;
  }

  return queryParams;
};

export const jeopardyApi = {
  getAtRiskUsers: async (params?: AtRiskUsersParams): Promise<AtRiskUsersResponse> => {
    const response = await apiClient.get('/admin/jeopardy/at-risk-users', {
      params: buildQueryParams(params),
    });
    return response.data;
  },

  getCardiovascularJeopardy: async (params?: CardiovascularJeopardyParams): Promise<CardiovascularJeopardyResponse> => {
    const response = await apiClient.get('/admin/jeopardy/cardiovascular', {
      params: buildQueryParams(params),
    });
    return response.data;
  },
};
